import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const ContactUs = lazy(() => import('../../container/contact-us'));
const View = lazy(() => import('../../container/contact-us/View'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/contact-queries`} component={ContactUs} />
      <Route exact path={`${path}/contact-queries/view/:id`} component={View} />
    </Switch>
  );
}

export default PagesRoute;
